import { render, staticRenderFns } from "./MarketingCard.vue?vue&type=template&id=2d439ca8&scoped=true&lang=pug"
import script from "./MarketingCard.vue?vue&type=script&lang=js"
export * from "./MarketingCard.vue?vue&type=script&lang=js"
import style0 from "./MarketingCard.vue?vue&type=style&index=0&id=2d439ca8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d439ca8",
  null
  
)

export default component.exports